export const environment = {
    production: false,
    apiUrl: 'https://education-monitoring-dev.nurtech.dev/api',
};
